/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import { Input } from 'reactstrap';
import ApiCalls from '../../custom-classes/api-calls';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/

/**
 * Handles the selection of products
 */
class SelectorExam extends React.Component{

    constructor(props)
    {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);

        this.state = {
            options: [], // The options to fill the selection
            lessonId: this.props.data.lessonId.value
        };
    }

    /** Handle the updates
     * We cannot find a concrete response why this is needed here meanwhile the other selector components are not needed.
     * @param nextProps
     */
    componentWillReceiveProps(nextProps){
        this.setState({lessonId: nextProps.data.lessonId.value}, ()=>{
            this.callData();
        });
    }

    /**
     * Call the data API
     */
    callData(){
        // This is promise
        let apiCall = ApiCalls.getLessonExams(this.state.lessonId);
        let arrOptions = [];

        // After the api call, fill the data
        apiCall.then((data)=>{

            let dataReturned = data.Quizzes;

            // Translate the first selection
            arrOptions.push(
                <option key={"0"} value={"0"}>
                    <Translate id="report-student-average.select-exam" options={{renderInnerHtml: false}}/>
                </option>);

            // Now fill the selections
            for (let i = 0; i < dataReturned.length; i++) {
                arrOptions.push(
                    <option key={dataReturned[i].Id} value={dataReturned[i].Id}> {
                        '(' + dataReturned[i].LevelOfKnowledge +') ' +  dataReturned[i].Title
                    } </option>
                );
            }
        }).then(() =>{
            this.setState({
                options: arrOptions
            });
        });
    }

    /**
     * Call the webservices for the subscription and fill those selects
     * Component did mount is required for selects with API calls.
     */
    componentWillMount()
    {
        this.callData();
    }

    /**
     * Handles the change event to get the selected value. Do not change this function
     * @param event The event (on change)
     */
    handleChange = (event) => {
        this.setState({value: event.target.value}, ()=>{
            this.props.updateParent(this.state.value);
            return this.state.value;
        });
    };

    /**
     * Renders the item list
     * @returns {XML} Returns an XML of the selection
     */
    render(){
        return (
            <Input type="select" className="form-control" name="exams" onChange={this.handleChange} value={this.props.value}>
                {this.state.options}
            </Input>
        )
    }
}

export default SelectorExam;


// WEBPACK FOOTER //
// ./src/components/selectors/selector-exam.js